import React, { useState } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";

const IsStablingSelect = ({ checkedStablingOption, setCheckedStablingOption, defaultOption = false }) => {
  const { t } = useTranslation("otherInterface");

  const [stablingOption] = useState(["1", "0"]);

  const handleChangeSelect = (e) => {
    let data = e.target.value;
    setCheckedStablingOption(data);
  };

  return (
    <FormControl>
      <InputLabel id="demo-simple-select-label">{t("isStablingSelect.title")}</InputLabel>
      {/* No need to change on Autocomplete component (few options) */}
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={checkedStablingOption ?? null}
        onChange={handleChangeSelect}
      >
        {defaultOption && <MenuItem value={null}>{t("isStablingSelect.all")}</MenuItem>}
        {stablingOption.map((value) => (
          <MenuItem
            key={value}
            value={value}
          >
            {t("isStablingSelect." + value)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default IsStablingSelect;